import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCap12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconCap12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m6 1.89 4.664 2.208L6 6.308l-4.664-2.21zM5.572.988a1 1 0 0 1 .856 0l4.663 2.207a1 1 0 0 1 0 1.808L10 5.519v2.749l-.223.148L9.5 8l.277.416h-.001l-.002.002-.005.004-.017.01-.06.038a7.4 7.4 0 0 1-1.006.494A7.3 7.3 0 0 1 6 9.5a7 7 0 0 1-2-.298v1.78L2.5 11 1 10.982V8.493c0-.65.417-1.203 1-1.408V5.519L.908 5.002a1 1 0 0 1 0-1.808zM3 8.475v1.519L2.5 10 2 9.994V8.493C2 8.225 2.22 8 2.5 8c.274 0 .49.215.5.475m.957-.337A6.2 6.2 0 0 0 6 8.5a6.3 6.3 0 0 0 2.314-.464c.292-.117.524-.233.68-.319L9 7.714V5.993L6.428 7.211a1 1 0 0 1-.856 0L3 5.993v1.092c.473.166.837.562.957 1.053"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCap12);
